import * as yup from 'yup';

export const reconciliationSchema = yup.object().shape({
    amount: yup
        .string()
        .required('Amount is required')
        .matches(/^-?\d+(\.\d+)?$/, 'Amount must be a valid number')
        .test('is-number', 'Amount must be a valid number', (value) => {
            if (!value) return false;
            const num = parseFloat(value);
            return !isNaN(num) && num >= -999999 && num <= 999999;
        }),
    reason: yup
        .string()
        .required('Notes are required')
        .min(10, 'Notes must be at least 10 characters')
        .max(500, 'Notes cannot exceed 500 characters'),
});

export type ReconciliationFormValues = yup.InferType<typeof reconciliationSchema>;
